import { CellType, TableConfig } from '@common/types';
import { AttachmentColumn, DriverComment, LastStatus, LastStatusDT } from '../../../monitoring/common/column';

export const tableConfig: TableConfig = {
  columns: [
    {
      title: '№',
      dataIndex: 'ID',
      key: 'ID',
      //
      active: true,
      type: CellType.Int,
      ellipsis: true,
      width: 60,

      sorting: 3,

      invisible: true
    },
    {
      title: 'ТС',
      dataIndex: 'Name',
      key: 'Name',
      active: true,
      type: CellType.Input,
      ellipsis: true,
      filtering: 'array',
      width: 120,

      sorting: 3
    },
    {
      title: 'Рег.Номер',
      dataIndex: 'Number',
      key: 'Number',
      active: true,
      type: CellType.RegNumber,
      ellipsis: true,
      filtering: 'array',
      width: 110,

      sorting: 3
    },
    {
      title: 'Водитель',
      dataIndex: 'DriverName',
      key: 'DriverName',
      active: true,
      type: CellType.Input,
      ellipsis: true,
      filtering: 'array',
      width: 150,

      sorting: 3
    },
    {
      title: 'Телефон',
      dataIndex: 'Phone',
      key: 'Phone',
      active: true,
      type: CellType.Input,
      filtering: 'string',
      ellipsis: true,
      width: 110,

      sorting: 3
    },
    {
      title: 'Адрес доставки',
      dataIndex: 'Address',
      key: 'Address',
      active: true,
      type: CellType.Input,
      ellipsis: true,
      filtering: 'array',
      width: 180,

      sorting: 3
    },
    {
      title: 'Время прибытия фактическое',
      dataIndex: 'WaypointFactArrive',
      key: 'WaypointFactArrive',
      active: true,
      type: CellType.TimeStringUtc,
      ellipsis: true,

      sorting: 3
    },
    {
      title: 'Время прибытия по плану',
      dataIndex: 'WaypointPlanArrive',
      key: 'WaypointPlanArrive',
      active: true,
      type: CellType.TimeStringUtc,
      ellipsis: true,

      sorting: 3
    },
    {
      title: 'Опоздание',
      dataIndex: 'Delay',
      key: 'Delay',
      active: true,
      type: CellType.String,
      filtering: 'string',
      ellipsis: true,
      width: 110,

      sorting: 3
    },
    {
      title: 'Комментарий',
      dataIndex: 'Comment',
      key: 'Comment',
      active: false,
      type: CellType.String,
      ellipsis: true,
      filtering: 'string',
      width: 100,

      sorting: 3
    },
    AttachmentColumn,
    DriverComment,
    LastStatus,
    LastStatusDT,
    {
      title: 'Просмотрено',
      titleText: 'Просмотрено',
      titleTooltip: 'Просмотрено',
      dataIndex: 'Viewed',
      key: 'Viewed',
      active: true,
      type: CellType.IconAction, //to new => checkboxIcon
      ellipsis: true,
      width: 120,

      sorting: 3
    }
    //убрали до реализации функционала
    // {
    //   title: 'Избранное',
    //   dataIndex: 'Favourite',
    //   key: 'Favourite',
    //   active: true,
    //   type: CellType.Select, //to new => checkboxIcon
    //   ellipsis: true,
    //   options: [
    //     { label: '', value: 0 },
    //     { label: 'Избранное', value: 1 }
    //   ],
    //   width: 70,
    //   editable: true,
    //
    //   sorting: 3,
    //
    //   filtering: 'array'
    // }
  ],
  adding: false,
  deleting: false,
  reloading: false,
  selecting: false,
  copying: false
};
